import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, unref as _unref, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-30b7c3ca"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row mb-3" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "col-12 member-h" }, "ポイント購入")
], -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row mb-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-12 text-center" }, "ご希望の金額を指定してください。")
], -1))
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "col-8 btn-buy" }
const _hoisted_5 = {
  key: 0,
  class: "row justify-content-center"
}
const _hoisted_6 = { class: "col-12 confirm" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { key: 2 }
const _hoisted_10 = { key: 3 }
const _hoisted_11 = { class: "row" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-6" }, "支払い方法：", -1))
const _hoisted_13 = { class: "col-6" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "クレジットカード", -1))
const _hoisted_15 = {
  key: 1,
  class: "row justify-content-center"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-12 confirm" }, [
  /*#__PURE__*/_createElementVNode("div", null, "店舗がPayPay支払いに対応していません")
], -1))
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = {
  key: 2,
  class: "row justify-content-center"
}
const _hoisted_19 = { class: "col-12 confirm" }
const _hoisted_20 = { key: 0 }
const _hoisted_21 = { key: 1 }
const _hoisted_22 = { key: 2 }
const _hoisted_23 = { key: 3 }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "支払い方法： PayPay", -1))
const _hoisted_25 = {
  key: 6,
  class: "text-red"
}
const _hoisted_26 = /*#__PURE__*/_createTextVNode("PayPayでお支払いが完了した後、必ずLINEアプリに戻ってください。")
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_28 = /*#__PURE__*/_createTextVNode("戻らずに画面を閉じるとポイントが加算されません。")
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_30 = /*#__PURE__*/_createTextVNode("誤って操作してしまった場合は店舗のスタッフにご連絡ください。")
const _hoisted_31 = [
  _hoisted_26,
  _hoisted_27,
  _hoisted_28,
  _hoisted_29,
  _hoisted_30
]
const _hoisted_32 = {
  key: 3,
  class: "row"
}
const _hoisted_33 = { class: "col-12 error" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "決済エラー", -1))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-center" }, [
  /*#__PURE__*/_createTextVNode(" 決済情報処理でエラーが発生しました。"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" ご登録の決済方法が有効であることをご確認ください。 ")
], -1))
const _hoisted_36 = { key: 0 }
const _hoisted_37 = { key: 1 }
const _hoisted_38 = { key: 2 }

import { Member, PointHistory, PaymentMethod, Shop, PointListType, Group } from '@/models';
import { Auth, DataStore } from 'aws-amplify';
import { inject, onMounted, reactive, ref, toRefs, watch, nextTick } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { CardListDto, CardPaymentDto } from '../../../../common/card.dto';
import Modal from '../../components/Modal.vue'
import 'dayjs/locale/ja'
import Qrcode from '@/components/Qrcode.vue';
import Payment from '@/components/Payment.vue';

interface Props {
  member: Member;
  shop: Shop;
  loading: boolean;
}

export default /*#__PURE__*/_defineComponent({
  props: {
    member: null,
    shop: null,
    loading: { type: Boolean }
  },
  emits: ['stopLoading','startLoading'],
  setup(__props: any, { emit }) {

const props = __props as {
  member: Member;
  shop: Shop;
  loading: boolean;
}

const route = useRoute();
const router = useRouter();



const { member, shop, loading } = toRefs(props);



const api: any = inject('api');

const card = ref<CardListDto>();
const selected = ref<PointListType>();
const pointLists = ref<(PointListType | null)[]>();

const payment = ref();

const success = ref(false);
const error = ref(false);

const confirm = async(item: PointListType) => {
  emit('startLoading');
  selected.value = item;

  emit('stopLoading');
}

const unselect = async() => {
  selected.value = undefined;
  card.value = undefined;
  error.value = false;
  emit('stopLoading');
}

const paymentCard = async() => {
  emit('startLoading');
  await payment.value.paymentCard(selected.value?.price);
  
}

const paymentPaypay = async() => {
  emit('startLoading');
  await payment.value.paymentPaypay(selected.value?.price, 'ポイント');
}


const cancelPaypay = async() => {
  await payment.value.cancelPaypay();
  unselect();
}

const saveNewPoint = async(paymentMethod: number) => {
  const newPoint = member.value?.point ? member.value.point + selected.value!.point : selected.value!.point;

  await DataStore.save(
    Member.copyOf(member.value! , updated => {
      updated.point = newPoint
    })
  );

  await DataStore.save( new PointHistory({
    usageType : 0,
    paymentMethod : paymentMethod,
    memo : 'Buy point ' + selected.value!.point,
    addPoint : selected.value!.point,
    usePoint : 0,
    totalPoint : newPoint,
    memberID : member.value?.id
  }));
}

const onsuccess = async () => {
  await saveNewPoint(member.value.paymentMethod == 1 ? 3 : 0);
  success.value = true;
  emit('stopLoading');
}

const onerror = (message: string) => {
  console.log(message);
  error.value = true;
  emit('stopLoading');
}

watch([member, shop], async() => {
  try {
    console.log('updated ' + member.value.name);
  
    await nextTick();

    console.log('updated ' + shop.value.name);
    const group = (await DataStore.query(Group, (g) => g.id('eq', shop.value.groupID!)))[0];
    pointLists.value = group.pointLists!;

    const key = await api.generateEncryptedKeys(`${shop.value.squareAppId}$${shop.value.squareLocationId}$${shop.value.squareAccessToken}`);

    const cardList = await api.getCards(member.value.squareCustomerId, key);
    card.value = cardList.filter((x: CardListDto)  => x.cardId == member.value!.currentSquareCardId)[0];
  }
  catch(e) {
    console.log(e);
  }

  emit('stopLoading');
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _hoisted_2,
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pointLists.value, (item, idx) => {
      return (_openBlock(), _createElementBlock("div", {
        key: idx,
        onClick: ($event: any) => (confirm(item!)),
        class: "row justify-content-center mb-3"
      }, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", null, _toDisplayString(item?.price?.toLocaleString()) + "円", 1),
          _createElementVNode("div", null, _toDisplayString(item?.point) + "ポイント分", 1)
        ])
      ], 8, _hoisted_3))
    }), 128)),
    (_unref(shop))
      ? (_openBlock(), _createBlock(Payment, {
          key: 0,
          ref_key: "payment",
          ref: payment,
          member: _unref(member),
          shop: _unref(shop),
          onOnerror: onerror,
          onOnsuccess: onsuccess
        }, null, 8, ["member", "shop"]))
      : _createCommentVNode("", true),
    _createVNode(Modal, {
      visible: selected.value != undefined && !_unref(loading),
      onHide: unselect
    }, {
      default: _withCtx(() => [
        (_unref(member).paymentMethod != 1 && card.value && !error.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                (!success.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, "ポイント購入確認"))
                  : _createCommentVNode("", true),
                (success.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, "決済"))
                  : _createCommentVNode("", true),
                _createElementVNode("div", null, _toDisplayString(selected.value!.price?.toLocaleString()) + "円", 1),
                _createElementVNode("div", null, _toDisplayString(selected.value!.point) + "ポイント分", 1),
                (!success.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, "決済してよろしいですか？"))
                  : _createCommentVNode("", true),
                (success.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, "決済が完了しました"))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_11, [
                  _hoisted_12,
                  _createElementVNode("div", _hoisted_13, [
                    _hoisted_14,
                    _createElementVNode("div", null, "下4桁 " + _toDisplayString(card.value!.maskedNumber!.slice(-4)), 1),
                    _createElementVNode("div", null, "有効期限 " + _toDisplayString(card.value!.month) + "/" + _toDisplayString(card.value!.year?.slice(-2)), 1)
                  ])
                ]),
                (!success.value && !_unref(loading))
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 4,
                      class: "btn-modal",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (paymentCard()))
                    }, "はい"))
                  : _createCommentVNode("", true),
                (!success.value && !_unref(loading))
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 5,
                      class: "btn-modal",
                      onClick: unselect
                    }, "キャンセル"))
                  : _createCommentVNode("", true),
                (success.value)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 6,
                      class: "btn-modal",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(router).push('/')))
                    }, "ホームへ戻る"))
                  : _createCommentVNode("", true)
              ])
            ]))
          : _createCommentVNode("", true),
        (_unref(member).paymentMethod == 1 && !_unref(shop).paypayApiKey && !error.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_15, _hoisted_17))
          : _createCommentVNode("", true),
        (_unref(member).paymentMethod == 1 && _unref(shop).paypayApiKey && !error.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, [
                (!success.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_20, "ポイント購入確認"))
                  : _createCommentVNode("", true),
                (success.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_21, "決済"))
                  : _createCommentVNode("", true),
                _createElementVNode("div", null, _toDisplayString(selected.value!.price?.toLocaleString()) + "円", 1),
                _createElementVNode("div", null, _toDisplayString(selected.value!.point) + "ポイント分", 1),
                (!success.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_22, "決済してよろしいですか？"))
                  : _createCommentVNode("", true),
                (success.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_23, "決済が完了しました"))
                  : _createCommentVNode("", true),
                _hoisted_24,
                (!success.value && !_unref(loading))
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 4,
                      class: "btn-modal",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (paymentPaypay()))
                    }, "はい"))
                  : _createCommentVNode("", true),
                (!success.value && !_unref(loading))
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 5,
                      class: "btn-modal",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (cancelPaypay()))
                    }, "キャンセル"))
                  : _createCommentVNode("", true),
                (!success.value && !_unref(loading))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_25, _hoisted_31))
                  : _createCommentVNode("", true),
                (success.value)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 7,
                      class: "btn-modal",
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_unref(router).push('/')))
                    }, "ホームへ戻る"))
                  : _createCommentVNode("", true)
              ])
            ]))
          : _createCommentVNode("", true),
        (error.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
              _createElementVNode("div", _hoisted_33, [
                _hoisted_34,
                _hoisted_35,
                (card.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_36, "支払い方法：" + _toDisplayString(card.value!.brand), 1))
                  : _createCommentVNode("", true),
                (card.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_37, "下4桁 " + _toDisplayString(card.value!.maskedNumber!.slice(-4)), 1))
                  : _createCommentVNode("", true),
                (card.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_38, "有効期限 " + _toDisplayString(card.value!.month) + "/" + _toDisplayString(card.value!.year?.slice(-2)), 1))
                  : _createCommentVNode("", true),
                _createElementVNode("div", {
                  class: "btn-modal",
                  onClick: unselect
                }, "閉じる")
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}
}

})